import { UseCase } from 'api/types';
import { useGetWidgetSettings } from 'hooks/customization';
import { useAuth } from 'shared/lib/auth/useAuth';

type UseIsGovernmentEnterpriseResult = {
  isGovernmentEnterprise: boolean;
  /** Widget settings are still loading for a client company, so the flag above may still flip to true. */
  isPending: boolean;
};

/**
 * Enterprise (``client``) accounts on the government vertical. Self-serve and individual companies are
 * excluded even when they pick the Government use case, since their billing surfaces still apply to them.
 */
export const useIsGovernmentEnterprise = (): UseIsGovernmentEnterpriseResult => {
  const { user } = useAuth();
  const { data: widgetSettings, isPending } = useGetWidgetSettings();
  const isCompanyClient = Boolean(user?.isCompanyClient);

  return {
    isGovernmentEnterprise: isCompanyClient && widgetSettings?.use_case === UseCase.GOVERNMENT,
    isPending: isCompanyClient && isPending,
  };
};
